import { AmexLogo, MastercardLogo, VisaLogo } from "../assets/logos/banks";
import { EXTRA_TYPES, KIOSK_KEYBOARD_SELECTOR } from "./constants";

const condfigFormat = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

export const formatMoney = (value) => {
    return condfigFormat.format(isNaN(value) ? 0 : value);
}

export const isEmptyValue = (value) => {
    return typeof value == 'undefined' || value == null || value == '';
}


export const drawSignature = (signature, imageSize) => {
    const oSvgDescription = {
        height: imageSize.maxY - imageSize.minY + 40,
        width: imageSize.maxX - imageSize.minX + 40,
        aPolylines: [],
    }

    signature = signature.filter(value => (
        value.x === "FFFF"
        ||
        value.y === "FFFF"
        ||
        (value.x !== "FFFF" && value.y !== "FFFF" && value.y.length < 4 && value.x.length < 4))
    );

    const aPointsLine = [[]];
    signature.forEach(function (value, index, array) {
        if (value.x !== "FFFF" && value.y !== "FFFF") {
            aPointsLine[aPointsLine.length-1].push((parseInt(value.x, 16) - imageSize.minX + 20) + "," + (parseInt(value.y, 16) - imageSize.minY + 20));
        } else if (index != signature.length - 1) {
            aPointsLine.push([])
        }
    });

    aPointsLine.forEach(aPoints => {
        if(!aPoints.length) return;
        const oPolyline = {
            sPoints: aPoints.join(' '),
            oStyle: { fill: 'none', stroke: 'black', strokeWidth: 2 },
        };
        oSvgDescription.aPolylines.push(oPolyline);
    });

    return oSvgDescription;
}

export const setSignatureSize = (signature) => {
    var minX = 65535;
    var minY = 65535;
    var maxX = 0;
    var maxY = 0;

    signature = signature.filter(function (value) {
        if (value.x !== "FFFF" && value.y !== "FFFF" && value.y.length < 4 && value.x.length < 4) {
            if (parseInt(value.x, 16) > maxX) {
                maxX = parseInt(value.x, 16);
            }
            if (parseInt(value.x, 16) < minX) {
                minX = parseInt(value.x, 16);
            }
            if (parseInt(value.y, 16) > maxY) {
                maxY = parseInt(value.y, 16);
            }
            if (parseInt(value.y, 16) < minY) {
                minY = parseInt(value.y, 16);
            }
            return true;
        }
        return false;
    });

    let size = {
        "minX": minX,
        "minY": minY,
        "maxX": maxX,
        "maxY": maxY
    };

    return size;
}

export const NormalizePaymentToGeneric = ({ authorizationCode, pspCode, paymentDate, total, cardBrand, signaturePoint }) => ({
    AuthorizationCode: authorizationCode,
    PspReference: pspCode,
    PaymentDate: paymentDate,
    CardBrand: cardBrand,
    Amount: total,
    SignaturePoint: signaturePoint ?? null
});

export const NormalizeCheckInToGeneric = ({ acquirerAprovedCode, acquirerTransactionID, saleData: { timeStamp }, total, signaturePoint, cardBrand }) => ({
    AuthorizationCode: acquirerAprovedCode,
    PspReference: acquirerTransactionID,
    PaymentDate: timeStamp,
    CardBrand: cardBrand,
    Amount: total,
    SignaturePoint: signaturePoint ?? null
});

export const GetBrandLogoByBrandName = (brand) => {
    return BRAND_LOGOS[brand];
}

export const BRAND_LOGOS = {
    'mc': MastercardLogo,
    'visa': VisaLogo,
    'amex': AmexLogo,
}

export const ConvertBase64ToFileImage = (data) => {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], "filenameTest", {type:mime});
}

export const TransformDateToCustomESIntl = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});

export const TransformOnlyDateToReadableESFormat = (date) => {
    return TransformDateToCustomESIntl.format(new Date(date)).split(',')[0]
}

export const ConvertCustomESIntlToReadable = (intlDate) => {
    return `${intlDate[0].value}/${intlDate[2].value}/${intlDate[4].value} ${intlDate[6].value}:${intlDate[8].value} ${intlDate[10].value}`
}

export const InitKioskKeyboard = () => {
    const allInput = document.querySelectorAll(KIOSK_KEYBOARD_SELECTOR);
    allInput.forEach(input => {
        input.dataset.kioskboardSpecialcharacters = true;
    });
    KioskBoard.run(KIOSK_KEYBOARD_SELECTOR);
};

export const ConvertArrayObjectsToLowerCaseKeys = (data) =>
  data.map(obj => Object.keys(obj).reduce((acc, key) => {
    acc[key.toLowerCase()] = obj[key];
    return acc;
  }, {}));

export const particlesRnd = (limit = 100) => {
    const result = [];
    const max = 30
    for (let index = 0; index < limit; index++) {
        result.push((Math.random() * max) + 10);
    }
    return result;
}

export const getExtraQtyByType = (extra) => {
    let qty = extra.itemQty;
    if (!extra.isCountable && extra.type == EXTRA_TYPES.daily) {
        qty = 1;
    }
    return qty;
}
